import { Button, Icon, useTheme } from '@mui/material'
import Grid from '@mui/material/Grid'
const WideEndIconButton = ({
  label,
  endIcon,
  disabled = false,
  onClick,
  ...otherProps
}) => {
  const theme = useTheme()
  const fontColor = theme.palette.background.paper
  return (
    <Button
      fullWidth
      disabled={disabled}
      onClick={onClick}
      size='small'
      color='primary'
      style={{paddingTop: 4, paddingBottom: 4}}
      {...otherProps}
      >

        {label}

      <Grid flex={1} display='inline-flex' justifyContent='right'>
        <Icon color={fontColor} sx={{ display: 'flex', alignItems: 'center' }}>
          {endIcon}
        </Icon>
      </Grid>
    </Button>
  )
}

export default WideEndIconButton
